import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
// import '../css/HomeMini.css'; 
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'

import Banner from './Banner';
import BannerSideBox from './BannerSideBox';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig'


class BannerMainBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            slides: [
                { title: 'Second item', description: '', path: '/telematicsportal/SliderImages/altpay_2.jpg' },
                { title: 'Third item', description: '', path: '/telematicsportal/SliderImages/altpay_3.jpg' },
                { title: 'Fifth item', description: '', path: '/telematicsportal/SliderImages/altpay_5.jpg' },
                { title: 'Sixth item', description: '', path: '/telematicsportal/SliderImages/altpay_6.jpg' },
                { title: 'Seventh item', description: '', path: '/telematicsportal/SliderImages/altpay_7.jpg' }
            ],
            totalCards: 0,
            totalMappedCards: 0,
            totalDevices: 0,
            totalMappedDevices: 0
        }
    }

    componentDidMount() {

        //console.log(this.props.data.selectedBranchNumber);

        const data = {
            AccountNo: this.props.selectedBranch,
        }
        console.log(data);
        axiosConfig.post('Portal/GetAccountmappingOverview', data)
            .then(res => {

                this.setState({
                    totalCards: res.data.accountOverviewMapping[0].totalCards,
                    totalMappedCards: res.data.accountOverviewMapping[0].totalMappedCards,
                    totalDevices: res.data.accountOverviewMapping[0].totalDevices,
                    totalMappedDevices: res.data.accountOverviewMapping[0].totalMappedDevices,
                })
            })
            .catch(function (error) {
            }
            )
    }

    render() {

        return (
            <section id="carousel-options">
                <div className="row match-height">
                    <CardDeck>
                        <div className="col-md-8 col-sm-12">



                            <Banner array={this.state.slides} />
                        </div>
                        <div className="col-md-4 col-sm-12">
                            {/* <BannerSideBox noOfCards="10" noOfTracker="8" noOfFuelSensor="8" AccountNo="PK00000009" remaning=" 2" remaning1=" 2" /> */}
                            <BannerSideBox
                                noOfDevices={this.state.totalMappedDevices}
                                noOfMappedCards={this.state.totalMappedCards}
                                noOfFuelSensor={this.state.totalMappedDevices}
                                AccountNo={this.props.selectedBranch}
                                remaning={this.state.totalCards - this.state.totalMappedCards}
                            />
                        </div>
                    </CardDeck>
                </div>
            </section>
        );
    }
}


export default BannerMainBox;